<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
import Main from './views/Main'

export default {
  name: 'app',
  components: {
    Main
  }
}
</script>

<style>
#app {
  font-family: 'Lora', serif;  
}
</style>
